export enum Role {
    Admin = 'admin',
    Calidad = 'calidad',
    Envasado = 'envasado',
    JefeTurno = 'jefe_turno',
    Logistico = 'logistico',
    Mizu = 'mizu',
    Planificador = 'planificador',
    Preparación = 'preparacion'
  }
  